import { render, staticRenderFns } from "./DesignerDetail.vue?vue&type=template&id=4698cb96&scoped=true&"
import script from "./DesignerDetail.vue?vue&type=script&lang=js&"
export * from "./DesignerDetail.vue?vue&type=script&lang=js&"
import style0 from "./DesignerDetail.vue?vue&type=style&index=0&id=4698cb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4698cb96",
  null
  
)

export default component.exports